import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { inr, pct, qtyUnits } from '@/components/po-grn/format';

const show = (v, type) => {
  if (type === 'money') return inr(v);
  if (type === 'pct') return pct(v);
  if (type === 'units') return qtyUnits(v);
  if (type === 'days') return v === null || v === undefined ? '—' : `${v} d`;
  return v === null || v === undefined ? '—' : Number(v).toLocaleString('en-IN');
};

export const SAKpis = ({ items, data, onDrill, testPrefix }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid={`${testPrefix}-kpis`}>
    {items.map(({ key, label, type, drill, warn, note }, i) => {
      const v = data?.[key];
      const bad = (typeof v === 'number' && v < 0) || (warn && v > 0);
      return (
        <button key={key} type="button" disabled={!drill} onClick={() => drill && onDrill(drill, label)}
          className={`text-left rounded-lg border bg-white px-4 py-3 border-l-4 transition-shadow animate-in fade-in slide-in-from-bottom-1 ${bad ? 'border-l-red-500' : 'border-l-orange-500'} border-orange-100 ${drill ? 'hover:shadow-md cursor-pointer' : 'cursor-default'}`}
          style={{ animationDelay: `${i * 25}ms`, animationFillMode: 'both' }} data-testid={`${testPrefix}-kpi-${key}`}>
          <div className="text-[11px] font-semibold uppercase tracking-wide text-stone-500 leading-tight">{label}</div>
          <div className={`mt-1.5 ${type === 'units' ? 'text-sm' : 'text-xl'} font-bold tabular-nums ${bad ? 'text-red-600' : 'text-[#3b2416]'}`} data-testid={`${testPrefix}-kpi-${key}-value`}>
            {data ? show(v, type) : '—'}
          </div>
          {note && data && <div className="text-[10px] text-stone-500 mt-1 leading-snug" data-testid={`${testPrefix}-kpi-${key}-formula`}>{typeof note === 'function' ? note(data) : note}</div>}
        </button>
      );
    })}
  </div>
);

export const ProvisionalBanner = ({ k }) => {
  if (!k || k.margin_confirmed !== false || !k.unresolved_lines) return null;
  return (
    <div className="flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-2 text-xs text-amber-800" data-testid="sa-provisional-banner">
      <AlertTriangle size={15} /> Margin figures are <b>provisional</b>: {k.unresolved_lines} line(s) have unresolved price, tax or unit basis and are excluded
      from margin totals (pricing coverage {pct(k.margin_coverage_pct)} of sales value).
    </div>
  );
};
